import request from '@arcgis/core/request';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';

import FeatureLayerProperties = __esri.FeatureLayerProperties;

interface featureLayerProps extends FeatureLayerProperties {
    layerName: string;
}

/**
 * Fetches a FeatureLayer's REST metadata from a MapServer/FeatureServer URL, finds the layer by name, and returns a new FeatureLayer instance configured with a transparent renderer and the specific layer's URL.
 *
 * A thin red-renderer (yellow outline on transparent fill) is applied by default so the entire parcel area is fill-drawn rather than just a point. The layer's id is matched case-insensitively against the name parameter.
 *
 * @returns A configured FeatureLayer instance ready to be added to a map.
 */
export const getFeatureLayerByLayerName = async ({
                                                     layerName,
                                                     url,
                                                     definitionExpression,
                                                     ...featureProps
                                                 }: featureLayerProps): Promise<FeatureLayer> => {
    const result = await request(`${url}?f=pjson`);
    const layer = result.data.layers.find(
        (i: any) => i.name.toLocaleLowerCase() == layerName.toLocaleLowerCase()
    );
    return new FeatureLayer({
        renderer: new SimpleRenderer({
            symbol: {
                type: 'simple-fill',
                color: 'transparent',
                outline: {
                    width: 2,
                    color: 'rgba(255,253,0,0.62)'
                }
            } as any
        }),
        url: `${url}/${layer.id}`,
        definitionExpression,
        ...featureProps
    });
};
